
// import _ from "lodash";
import { DataStore } from "./core";
import { throttleTimer } from "../../utils";
import VuexStore from "@/store";
import EventBus from "@/event-bus";

// Store All Communicate Messages
class Message extends DataStore {
  constructor(name) {
    super(name);
  }
  async sync() {
    // Sync Messages and Indexed between Memory (Map)

    // 1. Sync from Disk (IndexedDB) to Memory (Map);
    // 2. Sync from Memory to Disk
    // 3. Sync from Server to Client
    // 4. Sync from Client to Server
  }
  async store (payload) {
    const { channel, id, data } = payload;
    if (channel && id && data) {

      // Store Messages and Indexes to Local Disk (IndexedDB) from Memory (Map)
      // console.log("Store", payload);
      //
      const timestamp = new Date().getTime();

      // Unified ID that can access in both IndexedDB and Redis with O(1);
      const unify_id = "";

      const message = {
        ...data,
        unify_id,
        id: channel + "/" + id,
        channel,
        timestamp,
        onClient: true
      }
      await this.idb.data.put(message);
    }
  }
  async restore(opts = {}) {
    // Restore message cache from IndexedDB
    // console.log("Restoring Message Cache", this);
    /* eslint-disable no-unused-vars */
    const { init } = opts;

    if (this.idb) {
      const list = await this.idb.list.toArray();
      // console.log("Message lists restored", list);
    }
  }
  save(type, channel, id, data, extra) {
    if (!channel || !id) { return }

    const id_escaped = id.includes(channel + "/") ? id.split("/")[1] : id;

    const _id = channel + "/" + id_escaped;

    let _data = null;
    let unify_id;

    switch (type) {
      case "list":
        unify_id = `${channel}/${id_escaped}`;
        _data = createListData(channel, id_escaped, data);
        if (_data) {
          _data.id = _id;
          _data.internal_id = id_escaped;
          _data.unify_id = unify_id;
          this.list.set(unify_id, _data);
          this.idb.list.put(_data).then();
        }
        break;
      case "topic":
        unify_id = `${type}/${channel}/${id_escaped}`;
        _data = createTopicData(channel, id_escaped, data);
        if (_data) {
          _data.id = _id;
          _data.internal_id = id_escaped;
          _data.unify_id = unify_id;
          this.topic.set(unify_id, _data);
          this.idb.topic.put(_data).then();
        }
        break;
      case "message":
        unify_id = `${channel}/${id_escaped}`;
        _data = createMessageData(channel, id_escaped, data);
        if (_data) {
          _data.id = _id;
          _data.internal_id = id_escaped;
          _data.unify_id = unify_id;
          _data.topicId = extra.id;

          this.data.set(unify_id, _data);
          this.idb.data.put(_data).then();
        }
        break;
      default:
        return
    }
  }
  async load(type, channel, id, extra) {
    // Load message from message pool or IndexedDB
    if (!type || !channel || !id) { return null }
    let data = null;
    if (!this.apiCallBuffer) {
      this.apiCallBuffer = { list: [], channel }
    }

    const _id = `${channel}/${id}`;
    switch (type) {
      case "list":
        data = this.list.get(_id);
        break;
      case "topic":
        data = this.topic.get(_id);
        if (!data) {
          data = await this.idb.topic.get(_id);
          this.topic.set(_id, data);
        }
        break;
      case "message":
        data = this.data.get(_id);
        if (!data) {
          data = await this.idb.data.get(_id);
          // console.log("Message Loading from IndexedDB", _id, data);
          if (!data) {
            this.apiCallBuffer.list.push({ id });
            // if (!this.timer) { this.timer = null; }

            // console.log(_.throttle);

            await throttleTimer(async () => {
              // Request message from server
              const response = await this.VuexStore.dispatch("Communication/getMessagesByIds", this.apiCallBuffer);
              this.apiCallBuffer = null;

              const { status, data } = response;

              if (status.success && data[channel]) {
                for (let message of data[channel]) {
                  this.save(type, channel, message.id, message, extra);
                }
              }
            }, 200);
          }
        }
        break;
      default:
        break;
    }
    return data;
  }
  async update(type, channel, id, data) {
    // console.log("Updating new data", type, channel, id, data);

    const prevData = await this.load(type, channel, id);
    const newData = dataAdaptorSelector(type, channel, id, data);
    data = Object.assign(prevData, newData);
    this.save(type, channel, id, data);
    EventBus.$emit("new-message", data);
  }
  async getList(channel, listname) {
    if (!channel || !listname) { return null }

    const id = `${channel}/${listname}`;

    let list = this.list.get(id);

    if (typeof list === "undefined") {
      list = await this.idb.list.get(id)
    }

    return list;
  }
  async saveList(channel, listname, list) {
    const id = `${channel}/${listname}`;
    const data = createListData(channel, id, list);
    this.list.set(id, data);
    await this.idb.list.put(data).then();
  }
  generateIndexes() {
    const keys = this.data.keys();
    // console.log(keys);
  }
  getState(channel, type) {
    // This method for counting, storing and sync unread message.
    // Read all unread from IDB using query "unread" and "channel"
    const stateOfType = this.state.get(type);
    const state = stateOfType.get(channel);
    // console.log(channel, state);

    if (!state) {
      this.idb.state.get(`${channel}/${type}`).then(r => {
        // console.log(channel, "Counter", r);
        if (!r) {
          // console.log("Fetch state from Server");
        }
      })
    }
  }
  checkUpdate(channel, type, prevData = {}) {
    // console.log("Datastore/Message/checkUpdate()", channel, type, prevData, VuexStore);
    const { checksum } = prevData;
    VuexStore.dispatch("Communication/checkUpdate", { channel, type, id: prevData.id, checksum })
    .then((response = {}) => {
      const { status, data } = response;
      // console.log(response);
      if (!status.success && !data) {
        // Response with error
        return
      }

      if (data[channel].id === prevData.id) {
        // Commit new data
        // console.log("Commit new data", data);
        this.update(type, channel, data[channel].id, data[channel]).then();
      }
    })
    .catch();

  }
}

export default new Message("message");

// Store All Communicate Messages
/* export default {
  idbName: "message",
  idb: null,
  data: new Map(),
  topic: new Map(),
  list: new Map(),
  async createIndexedDB(userUUID) {
    await createIndexedDBHelper(userUUID, this);
  },
  async sync() {
    // Sync Messages and Indexed between Memory (Map)

    // 1. Sync from Disk (IndexedDB) to Memory (Map);
    // 2. Sync from Memory to Disk
    // 3. Sync from Server to Client
    // 4. Sync from Client to Server
  },
    async store (payload) {
      const { channel, id, data } = payload;
      if (channel && id && data) {

        // Store Messages and Indexes to Local Disk (IndexedDB) from Memory (Map)
        // console.log("Store", payload);
        //
        const timestamp = new Date().getTime();

        // Unified ID that can access in both IndexedDB and Redis with O(1);
        const unify_id = "";

        const message = {
          ...data,
          unify_id,
          id: channel + "/" + id,
          channel,
          timestamp,
          onClient: true
        }
        await this.idb.data.put(message);
      }
    },
    async restore(opts = {}) {
      // Restore message cache from IndexedDB
      console.log("Restoring Message Cache", this);
      const { init } = opts;

      if (this.idb) {
        const list = await this.idb.list.toArray();
        console.log("Message lists restored", list);
      }
    },
    save(type, channel, id, data) {
      if (!channel || !id) { return }

      const id_escaped = id.includes(channel + "/") ? id.split("/")[1] : id;

      const _id = channel + "/" + id_escaped;

      const unify_id = type === "list" ? `${channel}/${id_escaped}` : `${type}/${channel}/${id_escaped}`;
      let _data = null;

      switch (type) {
        case "list":
          _data = createListData(channel, id_escaped, data);
          if (_data) {
            _data.id = _id;
            _data.internal_id = id_escaped;
            _data.unify_id = unify_id;
            this.list.set(unify_id, _data);
            this.idb.list.put(_data).then();
          }
          break;
        case "topic":
          _data = createTopicData(channel, id_escaped, data);
          if (_data) {
            _data.id = _id;
            _data.internal_id = id_escaped;
            _data.unify_id = unify_id;
            this.topic.set(unify_id, _data);
            this.idb.topic.put(_data).then();
          }
          break;
        default:
          return
      }

    },
    async load(type, channel, id) {
      // Load message from message pool or IndexedDB
      if (!type || !channel || !id) { return null }
      let data = null;

      const _id = `${channel}/${id}`;
      switch (type) {
        case "list":
          data = this.list.get(_id);
          break;
        case "topic":
          data = this.topic.get(_id);
          if (!data) {
            data = await this.idb.topic.get(_id);
            this.topic.set(_id, data)
          }
          break;
        default:
          break;
      }

      return data;
    },
    update(channel, id, data) {
        const prev = this.load(channel, id);
        const newData = Object.assign(prev, data);
        this.save(channel, id, newData);
    },
    async getList(channel, listname) {
      if (!channel || !listname) { return null }

      const id = `${channel}/${listname}`;

      let list = this.list.get(id);

      if (typeof list === "undefined") {
        list = await this.idb.list.get(id)
      }

      return list;
    },
    async saveList(channel, listname, list) {
      const id = `${channel}/${listname}`;
      const data = createListData(channel, id, list);
      this.list.set(id, data);
      await this.idb.list.put(data).then();
    },
    generateIndexes() {
        const keys = this.data.keys();
        console.log(keys);
    }
}; */

function dataAdaptorSelector(type, channel, id, data) {
  if (!type || !channel || !id || !data) {
    throw new Error("Invalid argument in dataAdaptorSelector")
  }
  switch (type) {
    case "list":
      return createListData(channel, id, data);
    case "topic":
      return createTopicData(channel, id, data);
    case "message":
      return createMessageData(channel, id, data);
    default:
      return
  }

}

function createListData(channel, id, data) {
  // Store Messages and Indexes to Local Disk (IndexedDB) from Memory (Map)
  if (channel && id && data) {

    const timestamp = new Date().getTime();

    // Unified ID that can access in both IndexedDB and Redis with O(1);
    // const unify_id = "";

    const list = {
      // unify_id,
      channel,
      id,
      data,
      timestamp,
      onClient: true
    }

    return list
  }
  return null;
}

function createTopicData(channel, id, _data) {
  // Store Messages and Indexes to Local Disk (IndexedDB) from Memory (Map)
  if (channel && id && _data) {

    const timestamp = new Date().getTime();

    // Unified ID that can access in both IndexedDB and Redis with O(1);
    // const unify_id = "";

    // Property is according to IndexedDB schema

    // To ensure that data is valid
    let __data;

    switch (channel) {
      case "pm":
        __data = processPMTopicData(_data);
        break;
      case "chat":
        __data = processChatTopicData(_data);
        break;
      case "webboard":
        __data = processWebboardTopicData(_data);
        break;
      default:
        break;
    }
    const { data, meta } =  __data;

    // console.log("Check", data, meta);

    if (data && meta) {
      const topic = {
        // unify_id,
        channel,
        id,
        data,
        timestamp,
        subjectId: meta.subjectId,
        sendFrom: meta.sendFrom,
        unread: meta.unread,
        date: meta.date
      }
      return topic
    }
  }
  return null;
}

function createMessageData(channel, id, _data) {
  // Store Messages and Indexes to Local Disk (IndexedDB) from Memory (Map)
  if (channel && id && _data) {

    const timestamp = new Date().getTime();

    // Unified ID that can access in both IndexedDB and Redis with O(1);
    // const unify_id = "";

    // Property is according to IndexedDB schema

    // To ensure that data is valid
    const { data, meta } = processPMMessageData(_data)

    // console.log("Check", data, meta);

    if (data && meta) {
      const topic = {
        // unify_id,
        channel,
        id,
        data,
        timestamp,
        subjectId: meta.subjectId,
        sendFrom: meta.sendFrom,
        unread: meta.unread,
        date: meta.date
      }
      return topic
    }
  }
  return null;
}

function processPMTopicData(_data) {
  const data = _data.data || _data;

  if (data) {
    // console.log("ProcessPMTopicData", data);
    const subjectId = data.courseOutlineRegistration.subject.id;
    const unread = data.readDate ? false : true;
    const sendFrom = data.fromUser ? data.fromUser.uuid : "unknown-code-" + data.fromUserCode;
    const date = new Date(data.sendDate);

    return {
      data,
      meta: {
        subjectId,
        unread,
        sendFrom,
        date
      }
    }
  }

  return null
}

function processChatTopicData(_data) {
  const data = _data.data || _data;

  if (data) {
    // console.log("ProcessChatTopicData", data);
    // const subjectId = data.courseOutlineRegistration.subject.id;
    // const unread = data.readDate ? false : true;
    // const sendFrom = data.fromUser ? data.fromUser.uuid : "unknown-code-" + data.fromUserCode;
    // const date = new Date(data.sendDate);

    return {
      data,
      meta: {
        // subjectId,
        // unread,
        // sendFrom,
        // date
      }
    }
  }

  return null
}

function processWebboardTopicData(_data)  {
  const data = _data.data || _data;

  if (data) {
    // console.log("ProcessWebboard/TopicData", data);
    // const subjectId = data.courseOutlineRegistration.subject.id;
    // const unread = data.readDate ? false : true;
    // const sendFrom = data.fromUser ? data.fromUser.uuid : "unknown-code-" + data.fromUserCode;
    // const date = new Date(data.sendDate);

    return {
      data,
      meta: {
        // subjectId,
        // unread,
        // sendFrom,
        // date
      }
    }
  }

  return null
}

function processPMMessageData(_data) {
  const data = _data.data || _data;

  if (data && data.__typename === "PrivateMessageReply") {
    // console.log("ProcessPMMessageData", data);
    const unread = data.readDate ? false : true;
    const sendFrom = data.fromUser ? data.fromUser.uuid : "unknown-code-" + data.fromUserCode;
    const date = new Date(data.sendDate);

    return {
      data,
      meta: {
        unread,
        sendFrom,
        date
      }
    }
  }

  return null
}
